import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  image: {
    width: '100%',
    objectFit: 'cover',
  },
}));

export default useStyles;
